import { render, staticRenderFns } from "./TSvgIcon.vue?vue&type=template&id=d504426e&scoped=true&"
import script from "./TSvgIcon.vue?vue&type=script&lang=js&"
export * from "./TSvgIcon.vue?vue&type=script&lang=js&"
import style0 from "./TSvgIcon.vue?vue&type=style&index=0&id=d504426e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d504426e",
  null
  
)

export default component.exports